export type PendingPaymentOrderLike = {
  paymentState?: string;
};

export const isPendingPaymentOrder = (order?: PendingPaymentOrderLike | null): boolean => {
  return order?.paymentState === 'Pending';
};
